// API
import { api } from '../configs/api/api';

// Models
import {
  IAppointmentSettings,
  ICorrespondenceTimes,
  IPrebookedTimes,
  ISessionAvailableAttributes, IStoreSession,
  IStoreSessionAttributes,
  IStoreSessionUpdates
} from '../interfaces/session-settings.interfaces';

export const SessionSettingsService = {
  fetchSessionAvailableAttributes: async (): Promise<{ data?: ISessionAvailableAttributes, error?: string }> => {
    try {
      const axiosResponse = await api.get('/company/session-settings/available-settings');
      return { data: axiosResponse.data };
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  fetchStoreSessionAttributes: async (): Promise<{ data?: IStoreSessionAttributes, error?: string }> => {
    try {
      const axiosResponse = await api.get('/company/session-settings/session-attributes');
      return { data: axiosResponse.data };
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  fetchAvailableCallPrebookedTime: async (): Promise<{ data?: IPrebookedTimes, error?: string }> => {
    try {
      const axiosResponse = await api.get('/company/session-settings/pay-per-minute-settings');
      return { data: axiosResponse.data };
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  updateAvailableCallPrebookedTime: async (call_prebooked_time: number | string): Promise<{
    data?: IPrebookedTimes,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.post('/company/session-settings/update-pay-per-minute-settings', { call_prebooked_time });
      return { data: axiosResponse.data };
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  fetchAvailableCorrespondenceTime: async (): Promise<{ data?: ICorrespondenceTimes, error?: string }> => {
    try {
      const axiosResponse = await api.get('/company/session-settings/correspondence-setting');
      return { data: axiosResponse.data };
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  fetchAppointmentsSettings: async (): Promise<{ data?: IAppointmentSettings, error?: string }> => {
    try {
      const axiosResponse = await api.get('/company/session-settings/appointment-setting');
      return { data: axiosResponse.data };
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  updateAppointmentsSettings: async (value: number | string, key: 'max_approval_hours' | 'max_user_cancellation_hours'): Promise<{
    data?: IAppointmentSettings,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.post('/company/session-settings/update-appointment-time', {
        key,
        value: +value
      });
      return { data: axiosResponse.data };
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  updateAvailableCorrespondenceTime: async (correspondence_message_time: number | string): Promise<{
    data?: ICorrespondenceTimes,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.post('/company/session-settings/update-correspondence-time', { correspondence_message_time });
      return { data: axiosResponse.data };
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  createStoreSessionAttributes: async (session: IStoreSessionUpdates): Promise<{
    session_setting?: IStoreSession,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.post('/company/session-settings/store-session-attributes', {
        ...session,
        call_buffer: 0
      });
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  updateStoreSessionAttributes: async (session: IStoreSessionUpdates): Promise<{
    session_setting?: IStoreSession,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.post('/company/session-settings/update-session-attributes', {
        ...session,
        call_buffer: 0
      });
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  deleteStoreSessionAttributes: async (session_setting_id: string | number): Promise<{
    message?: string,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.delete('/company/session-settings/delete-session-attributes', {
        params: { session_setting_id }
      });
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
}
